import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/cn';

const SIZES = {
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-8',
} as const;

export interface SpinnerProps {
  size?: keyof typeof SIZES;
  /**
   * What is being waited for, announced to screen readers. Passing nothing
   * makes the spinner decorative, which is right when visible text beside it
   * already says - a button reading "Uploading…" does not need saying twice.
   */
  label?: string;
  className?: string;
}

/** A busy indicator, for work that has started and has no measurable progress. */
export function Spinner({ size = 'md', label, className }: SpinnerProps) {
  return (
    <span role={label ? 'status' : undefined} className={cn('inline-flex', className)}>
      <Loader2 className={cn(SIZES[size], 'animate-spin')} aria-hidden />
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  );
}
